import styled from 'styled-components';
import { rem, mediaUp } from 'approot/shared/style';
import {
  fontSize20,
  fontWeightNormal,
} from 'approot/shared/styles/typography.style';
import { grey6, grey10 } from 'approot/shared/styles/colours.style';
import { standardFocusState } from 'approot/shared/styles/borders.style';
import { spacing4, spacing20 } from 'approot/shared/styles/spacing.style';

type AccordionStateProps = {
  isExpanded: boolean;
};

type AccordionContentStateProps = {
  isExpanded: boolean;
  hideWithCSSVisibility: boolean;
  isAccordionShell?: boolean;
};

type AccordionPanelProps = {
  isAccordionShell?: boolean;
};
export const AccordionPanel = styled.div<AccordionPanelProps>`
  ${({ isAccordionShell }) =>
    !isAccordionShell && `border-bottom: 1px solid ${grey6};`}
`;

export const AccordionContent = styled.div<AccordionContentStateProps>`
  box-sizing: border-box;

  ${({ isExpanded }) =>
    !isExpanded &&
    `
    max-height: 0px;
    padding-bottom: 0px;
    padding-top: 0px;
    overflow: hidden;
  `}

  ${({ isAccordionShell, isExpanded }) =>
    !isAccordionShell &&
    isExpanded &&
    `
        padding-bottom: ${rem(22)};
        padding-top: ${rem(spacing4)};
        ${mediaUp.md`
          padding-bottom: ${rem(41)};
        `}
      `}

  ${({ hideWithCSSVisibility, isExpanded }) =>
    hideWithCSSVisibility
      ? `
    display: ${isExpanded ? 'block' : 'none'};
  `
      : `
      visibility: ${isExpanded ? 'visible' : 'hidden'};
    `}

  @media print {
    display: block;
    max-height: 100%;
    padding-top: ${rem(spacing20)};
    padding-bottom: 0;
  }
`;

export const AccordionLabel = styled.span`
  line-height: ${rem(26)};
  flex: 0 0 90%;

  ${mediaUp.lg`
    font-size: ${rem(fontSize20)};
  `}
`;

export const AccordionHeading = styled.h2`
  margin-bottom: 0;
  position: relative;
`;

type AccordionButtonProps = {
  isAccordionShell?: boolean;
};
export const AccordionButton = styled.div<AccordionButtonProps>`
  background: none;
  border: none;
  display: flex;
  flex-wrap: wrap;
  font-size: ${rem(fontSize20)};
  font-weight: ${fontWeightNormal};
  text-align: left;
  min-height: ${rem(35)};
  padding: 0;
  position: relative;
  width: 100%;

  ${({ isAccordionShell }) =>
    !isAccordionShell &&
    `
    padding: ${rem(41)} 0 ${rem(39)} 0;
  `};

  ${standardFocusState}
  &:focus {
    z-index: 1;
  }

  @media print {
    padding: 10px 0;
  }

  ${mediaUp.sm`
    display: block;
  `}
`;

export const AccordionButtonIcon = styled.div<AccordionStateProps>`
  bottom: auto;
  margin-top: -${rem(spacing20)};
  right: 0;
  position: absolute;
  top: 50%;

  svg {
    fill: ${grey10};
    stroke: none;
    transition: transform 0.2s;
    transform: rotate(360deg);
  }

  ${({ isExpanded }) =>
    isExpanded &&
    `
    svg {
      transform: rotate(180deg);
    }
  `}

  @media print {
    display: none;
  }
}
`;
